import { Box, Typography } from "@jewlr/storybook/core"
import { FloatInput } from "@jewlr/storybook/form"
import { Formik, Form, Field } from "formik"
import PropTypes from "prop-types"
import React, { useCallback, useState } from "react"
import { connect } from "react-redux"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import { doForgotPassword } from "app-store-v2/app/actions"
import { AuthenticateModalTitle } from "areas/authenticate/jewlr/components"
import Modal, { closeModal } from "components/modal"
import { IS_JEWLR } from "helpers/application"

import { Cta } from "./components"

const InternalForgotPassword = ({ forgotPassword }) => {
  const [showContent, setShowContent] = useState(false)
  const [email, setEmail] = useState("")

  const afterShow = useCallback(() => {
    setShowContent(true)
  })

  return (
    <Modal afterShow={afterShow} show="#forgot-password" width="430px">
      {showContent && (
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={(values, formActions) => {
            formActions.setStatus("")
            const onSuccess = (email) => setEmail(email)
            forgotPassword(values.email, { ...formActions, onSuccess })
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .required("Please enter a valid email address.")
              .test(
                "test-email",
                "Please enter a valid email address.",
                (value) => isEmail(value || "")
              ),
          })}
        >
          {({ isSubmitting, status }) =>
            email ? (
              <Box textAlign="center">
                <Typography mb={3}>
                  If an account with {email} exists, you&apos;ll receive a link
                  to reset your password.
                </Typography>
                <Cta onClick={closeModal}>Close</Cta>
              </Box>
            ) : (
              <Form>
                <Box textAlign="center">
                  {IS_JEWLR() ? (
                    <AuthenticateModalTitle>
                      Forgot Your Password?
                    </AuthenticateModalTitle>
                  ) : (
                    <Typography mb={2}>FORGOT YOUR PASSWORD?</Typography>
                  )}
                  <Typography mb={2}>
                    Press Submit to have instructions on how to reset your
                    password emailed to you.
                  </Typography>
                  <Box mb={2}>
                    <Field name="email" type="email">
                      {({ field }) => (
                        <FloatInput
                          data-cy="forgot-password-email-input"
                          label="Email"
                          placeholder="Enter your email"
                          {...field}
                        />
                      )}
                    </Field>
                  </Box>
                  <Cta
                    data-cy="forgot-password-submit-button"
                    loading={isSubmitting}
                    type="submit"
                  >
                    Submit
                  </Cta>
                  {status && (
                    <Typography
                      color={status.color}
                      data-cy="forgot-password-status"
                      mt={2}
                    >
                      {status.message}
                    </Typography>
                  )}
                </Box>
              </Form>
            )
          }
        </Formik>
      )}
    </Modal>
  )
}

InternalForgotPassword.propTypes = {
  forgotPassword: PropTypes.func,
}
const mapStateToProps = () => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (email, formActions) => {
      dispatch(doForgotPassword(email, formActions))
    },
  }
}
const ForgotPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalForgotPassword)

export default ForgotPassword
